import React from 'react';
import { Wrap } from './Image.style';

const Image = ({ image, size }) => {
  console.log(image);

  if (!image) {
    return null;
  }

  if (!image.localFile) {
    return (
      <img
        src={image.source_url}
        alt={image.alt_text}
        loading="lazy"
        style={{ margin: '80px auto', display: 'block', maxWidth: '100%' }}
      />
    );
  }

  return (
    <Wrap size={size}>
      <source
        srcSet={image.localFile.childImageSharp.fluid.srcSetWebp}
        type="image/webp"
      />
      <source
        srcSet={image.localFile.childImageSharp.fluid.srcSet}
        type="image/jpeg"
      />
      <img
        src={image.localFile.childImageSharp.fluid.src}
        alt={image.alt_text}
        loading="lazy"
      />
    </Wrap>
  );
};

export default Image;
